export default "__VITE_ASSET__f4LWnPZF__"